/* Maerel London — wishlist (likes)
 *
 * A backend-free wishlist. Liked products are stored in localStorage as small
 * snapshots, so hearts persist across pages and the Likes page can render them
 * without a server round-trip. Per browser/device; no login required.
 *
 * Any element with [data-maerel-wish-toggle="<product-id>"] becomes a toggle.
 * It should also carry data-wish-* attributes describing the product so the
 * Likes page can rebuild the card. Toggles are handled via event delegation,
 * so dynamically rendered buttons (e.g. on the Likes page) work too.
 *
 * Exposes window.MaerelWishlist = { read, has, toggle, remove, count }.
 * Dispatches `maerel:wishlist:change` on document after every change.
 */
(function () {
  var KEY = 'maerel:wishlist';

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }

  function indexOf(list, id) {
    id = String(id);
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === id) return i;
    }
    return -1;
  }

  function has(id) {
    return indexOf(read(), id) >= 0;
  }

  function count() {
    return read().length;
  }

  // item: { id, handle, title, url, image, price, compare, variant, scents, contents }
  // Returns true if the item is now saved, false if it was removed.
  function toggle(item) {
    var list = read();
    var idx = indexOf(list, item.id);
    var added;
    if (idx >= 0) {
      list.splice(idx, 1);
      added = false;
    } else {
      list.push(item);
      added = true;
    }
    write(list);
    notify(item.id, added);
    return added;
  }

  function remove(id) {
    var list = read();
    var idx = indexOf(list, id);
    if (idx < 0) return false;
    list.splice(idx, 1);
    write(list);
    notify(id, false);
    return true;
  }

  function notify(id, added) {
    syncButtons();
    syncBadges();
    document.dispatchEvent(new CustomEvent('maerel:wishlist:change', {
      detail: { id: String(id), added: added, count: count() }
    }));
  }

  window.MaerelWishlist = {
    read: read,
    has: has,
    toggle: toggle,
    remove: remove,
    count: count
  };

  // ---- DOM sync -----------------------------------------------------------

  function paintButton(btn, on) {
    btn.classList.toggle('on', on);
    var svg = btn.querySelector('svg');
    if (svg) {
      if (on) {
        svg.setAttribute('fill', 'currentColor');
        svg.removeAttribute('stroke');
      } else {
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
      }
    }
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function syncButtons() {
    document.querySelectorAll('[data-maerel-wish-toggle]').forEach(function (btn) {
      paintButton(btn, has(btn.getAttribute('data-maerel-wish-toggle')));
    });
  }

  function syncBadges() {
    var n = count();
    document.querySelectorAll('[data-maerel-wish-count]').forEach(function (badge) {
      badge.textContent = n;
      if (n > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    });
  }

  function snapshotFrom(btn) {
    return {
      id: btn.getAttribute('data-maerel-wish-toggle'),
      handle: btn.getAttribute('data-wish-handle') || '',
      title: btn.getAttribute('data-wish-title') || '',
      url: btn.getAttribute('data-wish-url') || '',
      image: btn.getAttribute('data-wish-image') || '',
      price: btn.getAttribute('data-wish-price') || '',
      compare: btn.getAttribute('data-wish-compare') || '',
      variant: btn.getAttribute('data-wish-variant') || '',
      scents: btn.getAttribute('data-wish-scents') || '',
      contents: btn.getAttribute('data-wish-contents') || ''
    };
  }

  // ---- Wiring -------------------------------------------------------------

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-maerel-wish-toggle]');
    if (!btn) return;
    e.preventDefault();
    toggle(snapshotFrom(btn));
  });

  function init() {
    syncButtons();
    syncBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
